/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *
 */
//@ts-nocheck
import React, { useState, useRef } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import { SelectInput, TextInput, DatePicker } from './components';
import * as S from './styles';

export interface ICardInputProps {
  onApplyFilter(value: any): void;
  onClear(): void;
  filterTypes: any[];
}

export const CardInput = (props: ICardInputProps) => {
  const { onApplyFilter, filterTypes, onClear } = props;
  const [checkedType, setCheckedType] = useState<any>({
    is: false,
    isNot: false,
    contains: false,
    anyValue: false,
  });
  const [checkedValue, setCheckedValue] = useState<any>({
    is: null,
    isNot: null,
    contains: null,
    hasAnyValue: null,
  });

  const _handleSubmit = (event: any) => {
    event.preventDefault();

    let _appliedFilter = { ...checkedValue };
    Object.keys(_appliedFilter).forEach((key) => {
      if (!_appliedFilter[key]) delete _appliedFilter[key];
    });

    if (event) {
      console.log(`checked value`, _appliedFilter);
      onApplyFilter && onApplyFilter(_appliedFilter);
      document.getElementById('searchFilter')?.click();
    }
  };

  const onRadioChange = (id: string, event: any) => {
    console.log(`id is changed`, id, event?.target.checked);
    let _temp = {
      is: false,
      isNot: false,
      contains: false,
      anyValue: false,
    };
    setCheckedType({
      ..._temp,
      [id]: event.target.checked,
    });
  };

  const onValueChange = (item: any, id: string, value: any) => {
    console.log(`id is changed in onValueChange`, id, value);
    let _temp: any = {
      is: null,
      isNot: null,
      contains: null,
      hasAnyValue: null,
    };
    setCheckedValue({
      ..._temp,
      [id]: value,
      inputData: item,
    });
  };

  const _getInputFields = (item: any) => {
    if (
      checkedType[item?.label] &&
      (item?.type === 'text' || item?.type === 'email')
    ) {
      return (
        <TextInput
          item={item}
          id={item?.label}
          type={item?.type}
          onCompChange={onValueChange}
        />
      );
    }
    if (checkedType[item?.label] && item?.type === 'select') {
      return (
        <SelectInput
          item={item}
          type={item?.type}
          options={item?.options}
          id={item?.label}
          onCompChange={onValueChange}
        />
      );
    }
    if (checkedType[item?.label] && item?.type === 'datePicker') {
      return (
        <DatePicker item={item} id={item?.label} onCompChange={onValueChange} />
      );
    }
    // return(
    //   (checkedType[item?.id] &&  (item?.type === "text" || item?.type==="email")) ? (
    //     <Form.Control
    //       type="text"
    //       onChange={onValueChange.bind(null, item)}
    //     />
    //   )
    // )
  };

  return (
    <S.CardContainer>
      <Card.Body>
        <Form onSubmit={_handleSubmit}>
          {filterTypes?.map((item, i) => {
            return (
              <Form.Group className="mb-3">
                <Form.Check
                  type="radio"
                  name="filterType"
                  id={`${item?.label}-${i}`}
                  label={item?.label}
                  onChange={onRadioChange.bind(null, item?.label)}
                />
                {_getInputFields(item)}
              </Form.Group>
            );
          })}
          <Button
            type="reset"
            variant="gray"
            id="searchFilter"
            className="mx-2"
            onClick={() => onClear && onClear()}
          >
            Clear
          </Button>
          <Button type="submit" variant="secondary">
            Apply Filter
          </Button>
        </Form>
      </Card.Body>
    </S.CardContainer>
  );
};

CardInput.defaultProps = {
  filterTypes: ['is', 'isNot', 'contains', 'hasAnyValue'],
};
